/* Sisters Lemonade — report leads and phone taps to Google Analytics (GA4 G-TH49HQ1DD5).
 * Shopify's Google app only puts Google's tag on the page after the visitor accepts cookies,
 * and until 2026-10-15 the cookie banner showed to Georgia visitors, so for almost everyone
 * window.gtag did not exist and the gtag('event', ...) calls in the sl-*.js files went
 * nowhere; the main inquiry forms sent no lead event at all. This defines gtag on the page
 * and loads Google's tag for EVENTS ONLY: send_page_view is false because the app already
 * counts page views. It shares the app's _ga visitor id (checked 2026-10-15).
 * It follows the visitor's cookie choice: Google's tag does not load until Shopify's privacy
 * API says analytics is allowed. Events raised before that wait in dataLayer and go out if
 * the visitor accepts.
 * Events: generate_lead (sent by sl-hubspot-forms.js and sl-sample-pack.js on a successful
 * submit) and phone_call_click (any tel: link, wired below).
 */
(function () {
  var GA_ID = 'G-TH49HQ1DD5';
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function () { window.dataLayer.push(arguments); };
  }
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { send_page_view: false });

  var loaded = false;
  function load() {
    if (loaded) { return; }
    loaded = true;
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA_ID;
    document.head.appendChild(s);
  }

  function check() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && cp.analyticsProcessingAllowed()) { load(); }
  }

  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (!err) { check(); }
    });
  }
  document.addEventListener('visitorConsentCollected', check);

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href^="tel:"]') : null;
    if (a) {
      window.gtag('event', 'phone_call_click', { link_url: a.getAttribute('href'), page_path: location.pathname });
    }
  }, true);
})();
